<template>
  <div class="chat_div" >
    <div class="chat_sz" v-if="is_show">
      <div class="sz_btn" v-if="showChat==false" @click="showChat = !showChat">
        <img :src="config.avatar" class="botimg" alt="">
        <span>AI客服</span>
      </div>

      <div v-if="showChat" class="chatsz_window">
        <div class="chatsz_header">
          <div class="chatsz_avatar">
            <img :src="config.avatar" class="avatarimg" alt="" v-if="config.avatar">
            <img src="../assets/img/avatar.png" class="avatarimg" alt="" v-else>
            {{ config.title }}
          </div>
          <div class="sz_close" :style="{'--chat-bubble-color': config.theme}" @click="showChat = !showChat">
          </div>
        </div>

        <div class="chatsz_messages" ref="messageContainer">
          <div class="chatsz_logo">
            <img :src="config.logo" class="sz_logo" alt="" v-if="config.logo">
            <img src="../assets/img/avatar.png" class="sz_logo" alt="" v-else>
          </div>

          <div class="chatsz_welcome" :style="{'--chat-bubble-color': config.theme}">
            <div class="chatsz_welcome_text" :style="{'--chat-bubble-color': config.theme}">
              {{ config.welcome }}
            </div>
          </div>
          <!-- 常见问题  列表 -->
          <div class="chatsz_actions" v-if="config.recommendQuestions">
            <div :style="{'--chat-bubble-color': config.theme}"
                v-for="(question, index) in config.recommendQuestions"
                :key="index"
                closable
                @click="goQuestion(question)"
                class="chatsz_questions"
              >
                {{ question }}
            </div>
          </div>

          <div
            v-for="(msg, index) in messages"
            :key="index"
            :class="['chatsz_message', msg.sender]"
            :style="{'--chat-bubble-color': config.theme}"
          >
            <img :src="config.avatar" class="avatarimg" alt="" v-if="config.avatar&&msg.sender=='szbot'&&msg.text">
            <img src="../assets/img/avatar.png" class="avatarimg" alt="" v-if="!config.avatar&&msg.sender=='szbot'&&msg.text">
            <!-- msg.text 按照markdown格式显示 **加强前期准备工作，提升初审效率，降低成本** 星号内的文本会加粗，-->
             <div class="sz_bubble" v-if="msg.text" v-html="msg.text"></div>
            <!-- <div class="sz_bubble" v-if="msg.text">{{ msg.text }}</div> -->
          </div>
          <img src="../assets/img/loading.gif" class="avatarimg" alt="" v-if="loading">
        </div>

        <!-- 人工客服 -->
        <div class="chatsz_contact" v-if="config.is_online==1&&config.contact_content" v-html="sanitizedContent" :style="{'--chat-bubble-color': config.theme}">
        </div>

        <div class="input-area">
          <div class="custom-input">
            <input
              v-model="inputMsg"
              placeholder="请输入你的问题"
              @keyup.enter="sendszMessage"
              class="message-input"
            />
            <div class="sz_svg_send"  v-if="inputMsg" @click="sendszMessage" :style="{'--chat-bubble-color': config.theme}"></div>
            <div class="sz_svg"  v-else></div>
          </div>
          <div class="sz_rgkf" @click="config.is_online=1" v-if="config.contact_content">
            <div class="sz_svg_rgkf"  v-if="config.is_online" :style="{'--chat-bubble-color': config.theme}"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['config'],
  data() {
    return {
      is_show: this.config.is_show,
      showChat: false,
      inputMsg: "",
      streamingContent: '',
      loading: false,
      loadings:false,
      messages: []
    };
  },
  computed: {
    sanitizedContent() {
      return this.config.contact_content;
    }
  },
  methods: {
    sendszMessage2() {
      const eventSource = new EventSource('https://aee-api.scszcb.com/v1/chat-bot/chat/stream', {
        method: "POST",
        headers: {
          'Authorization': `Bearer ${this.config.api_key}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ query: this.inputMsg })
      });

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          // 将新的消息添加到消息列表中
          this.messages.push({
            sender: 'szbot',
            text: data.content || data.text
          });
        } catch (error) {
          console.error('解析消息数据失败:', error);
        }
      };

      eventSource.onerror = (err) => {
        console.error('SSE连接错误:', err);
        eventSource.close();
        this.loading = false;
      };

      // 添加连接打开事件处理
      eventSource.onopen = () => {
        console.log('SSE连接已建立');
        this.loading = true;
      };

      // 组件销毁时关闭连接
      this.$once('hook:beforeDestroy', () => {
        eventSource.close();
      });
    },

    // 优化流式返回的接口，有一个data显示一个data
    async sendszMessage() {
      if (this.loading) {
        return;
      }
      if (this.loadings==true) {
        return;
      }
      this.loading = true;
      if (!this.inputMsg.trim()) {
        this.loading = false;
        return;
      }
      if (
        this.inputMsg === "人工客服" ||
        this.inputMsg === "人工" ||
        this.inputMsg === "客服"
      ) {
        this.loading = false;
        this.config.is_online = 1;
        this.inputMsg = "";
        return;
      }
      // 用户消息
      this.messages.push({
        sender: "sz_user",
        text: this.inputMsg,
      });
      const key = "Bearer " + this.config.api_key;

      this.controller = new AbortController();

      try {
        // 采用ReadableStream流式读取，边下边显示
        const response = await fetch(
          "https://aee-api.scszcb.com/v1/chat-bot/chat/stream",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: key,
              "Cache-Control": "no-cache",
              "Connection": "keep-alive",
            },
            body: JSON.stringify({ query: this.inputMsg })
          }
        );

        if (!response.ok || !response.body) {
          throw new Error(`请求失败: ${response.status}`);
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let isDone = false;
        let index = 0;
        let botMsg = { sender: "szbot", text: "" };
        this.messages.push(botMsg);
        // 只要有新数据就立刻处理
        while (!isDone) {
          const { value, done } = await reader.read();
          isDone = done;
          if (value) {
            buffer += decoder.decode(value, { stream: !done });
            let lines = buffer.split('\n');
            buffer = lines.pop() || "";
            for (let line of lines) {
              line = line.trim();

              if (!line) continue;
              if (line.startsWith("data: ")) {
                let dataStr = line.slice(6);
                if (dataStr === "[DONE]") {
                  this.loading = false;
                  this.inputMsg = "";
                  this.loadings = false;
                  this.$nextTick(() => this.scrollToBottom && this.scrollToBottom());
                  return;
                }
                try {
                  let data = JSON.parse(dataStr);
                 // console.log(data,'aaaaaaaaaaa');

                  if(data.type=='security_error'){
                    this.loading = false;
                    this.inputMsg = "";
                    botMsg.text = data.error;
                    this.$forceUpdate();
                    return;
                  }
                  if(data.choices && data.choices[0].delta.content==null){
                    this.loading = true;
                  }
                  if (data.choices && data.choices[0].delta.content!=null) {
                    this.inputMsg = "";
                      //初始化一个对话，出现第一个内容的时候，初始化一个对话
                      // let botMsg = { sender: "szbot", text: "" };
                      // this.messages.push(botMsg);
                      this.loading = false;
                      console.log(index,'aaaaaaaaaaa');
                       if (data.choices[0].delta.content =='\n') {
                      //if (index<2) {
                        continue;
                      }else{
                        index++;
                      }
                    setTimeout(() => {
                        botMsg.text += data.choices[0].delta.content;
                        this.$forceUpdate();
                      }, (index-1) * 20);
                    this.loadings = true;
                  }
                } catch (e) {
                  console.error("解析数据失败:", e);
                }
              }
            }
          }
        }
        // 处理最后残留的buffer
        if (buffer) {
          let line = buffer.trim();
          if (line.startsWith("data: ")) {
            let dataStr = line.slice(6);
            if (dataStr !== "[DONE]") {
              try {
                let data = JSON.parse(dataStr);
                if (data.type === "message" && data.content) {
                  botMsg.text += data.content;
                  this.$forceUpdate();
                } else if (typeof data === "string") {
                  botMsg.text += data;
                  this.$forceUpdate();
                }
              } catch (e) {}
            }
          }
        }
      } catch (error) {
        this.loading = false;
        this.inputMsg = "";
        if (error.name !== "AbortError") {
          console.error("请求出错:", error);
          const msg = { sender: "szbot", text: "请重新输入" };
          this.messages.push(msg);
          this.$forceUpdate();
        }
      }
    },

    goQuestion(e) {
      this.inputMsg = e;
      this.sendszMessage();
    },

    scrollToBottom() {
      if (this.$refs.messageContainer) {
        this.$refs.messageContainer.scrollTop = this.$refs.messageContainer.scrollHeight;
      }
    },
    hexToRgb(hex) {
      hex = hex.replace(/^#/, '');
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `${r}, ${g}, ${b}`;
    }
  },

  updated() {
    this.scrollToBottom();
  },

  mounted() {
    this.scrollToBottom();
    this.config.theme = this.hexToRgb(this.config.theme);
  }
};
</script>

<style scoped>
.chat_div{
  display: flex;
  flex-direction: column;
  justify-content: center;
   position: fixed !important;
  right: 30px !important;
  top: 0px !important;
  height: 100%;
  z-index: 9999 !important;
}
.chat_sz {
  /* position: fixed !important;
  right: 30px !important;
  top: 360px !important; */
  z-index: 9999 !important;
}

.sz_btn {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: #ffffff;
  color: #3D3D3D;
  font-size: 12px;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  box-shadow: 0 2px 12px rgba(0,0,0,0.15) !important;
  /* transition: all 0.3s ease; */
}

.botimg{
  width: 44px;
  height: 44px;
  border-radius: 100%;
  margin-bottom: 5px;
}

.sz_btn:hover {
  background-color: #f5f5f5;
}

.chatsz_header {
  padding: 26px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.chatsz_avatar{
  display: flex;
  align-items: center;
font-weight: 500;
font-size: 18px;
color: #3D3D3D;
}
.avatarimg{
  width: 38px;
  height: 38px;
  border-radius: 100%;
  margin-right: 8px;
  float: left;
}

.sz_logo{
  width: 80px;
  height: 80px;
  text-align: center;
  border-radius: 100%;
}
.chatsz_logo{
  display: flex;
  justify-content: center;
}
.chatsz_window {
  width: 498px;
  /* height: 712px; */
  max-height: 864px;
  background: linear-gradient( 180deg, #FFFFFF 0%, #FFFFFF 66%);
  box-shadow: 2px 4px 12px 0px rgba(192,199,218,0.5);
  border-radius: 30px 30px 30px 30px;
  display: flex;
  flex-direction: column;
  /* position: fixed;
  top: 30px;
  right: 26px; */
}


.chatsz_welcome{
  width: 452px;
  margin: 0 auto;
  background-color: rgba(var(--chat-bubble-color),0.06) !important;
  border-radius: 18px;
  z-index: 1;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}
.chatsz_welcome_text{
  width: 436px;
  font-weight: 500;
  font-size: 16px;
  color: #3D3D3D;
  padding: 12px 24px;
  background-color: rgba(var(--chat-bubble-color),0.3) !important;
  border-radius: 18px;
  z-index: 9;
}

.chatsz_messages {
  min-height: 480px;
  padding: 24px !important;
  overflow-y: auto !important;
  flex-grow: 1;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.chatsz_messages::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
.chatsz_actions{
  display: flex;
  flex-direction: column;
  margin-top: 22px;
}
.chatsz_questions{
  max-width: 172px;
    min-height: 34px;
    display: flex;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid rgba(var(--chat-bubble-color), 0.6) !important;
    margin-bottom: 12px;
    align-items: center;
    padding: 0 20px;
    cursor: pointer;
}

/* 光标样式 */
.typewriter-cursor {
  border-right: 2px solid #333;
  animation: blink 0.75s step-end infinite;
}

@keyframes blink {
  50% { border-color: transparent; }
}

.sz_bubble {
  max-width: 400px !important;
  padding: 17px 18px !important;
  background-color: #f0f0f0 !important;
  word-break: break-word;
  white-space: pre-wrap;
}
.sz_user{
  width: 100%;
  margin-bottom: 18px;
  display: flex;
}
.sz_user .sz_bubble {
  background-color: rgba(var(--chat-bubble-color),1) !important;
  color: white !important;
  margin-left: auto;
  float:right;
  border-radius: 10px 0px 10px 10px;
}
.szbot{
  display: flex;
  width: 100%;
  margin-bottom: 18px;
}
.szbot .sz_bubble {
  border-radius: 0px 10px 10px 10px;
  margin-top: 14px;
  margin-left: 6px;
  line-height: 24px;
}
.chatsz_contact{
  width: 266px;
  padding: 18px;
  background-color: rgba(var(--chat-bubble-color),0.2) !important;
  border-radius: 10px 10px 10px 10px;
  margin-left: 24px;
  margin-bottom: 30px;
  line-height: 24px;
}
.input-area {
  display: flex;
  align-items: center;
  margin: 0 24px 28px 24px;
  justify-content: space-between;
}

.custom-input {
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(192,199,218,0.5);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #EAECEE;
  padding: 0 18px;
}

.message-input {
  flex-grow: 1;
  padding: 10px;
  border: none !important;
  border-radius: 4px;
  outline: none;
  font-size: 14px;
}
.sz_svg{
  width: 34px;
  height: 34px;
  background-color: #bdbec1; /* 通过这个颜色控制图标颜色 */
  -webkit-mask-image: url(../assets/img/send.svg);
  mask-image: url(../assets/img/send.svg);
  cursor: pointer;
}

.sz_svg_send{
  width: 34px;
  height: 34px;
  background-color: rgba(var(--chat-bubble-color),1) !important;
  -webkit-mask-image: url(../assets/img/send.svg);
  mask-image: url(../assets/img/send.svg);
  cursor: pointer;
}
.sz_close {
  width: 34px;
  height: 34px;
  background-color: rgba(var(--chat-bubble-color),1) !important;
  -webkit-mask-image: url(../assets/img/close.svg);
  mask-image: url(../assets/img/close.svg);
  cursor: pointer;
}
.sz_rgkf{
  width: 62px;
  height: 62px;
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(192,199,218,0.5);
  border-radius: 16px 16px 16px 16px;
  border: 1px solid #EAECEE;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;

}
.sz_svg_rgkf{
  width: 34px;
  height: 34px;
  background-color: rgba(var(--chat-bubble-color),1) !important;
  -webkit-mask-image: url(../assets/img/rgkf.svg);
  mask-image: url(../assets/img/rgkf.svg);
  cursor: pointer;
}

.message-input:focus {
  border-color: #409eff;
}

/deep/ .el-loading-spinner .path{
  stroke: #dddddd !important;
}

</style>
